import { useDispatch } from 'react-redux';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { closeLastModal, openModal } from 'reducers/modalReducer';
import { callBrBusinessEvent } from 'services/businessRelationService';
import { setBrTab } from 'reducers/brTabsReducer';
import { BrTabItems } from 'views/BrTabs/BrTabs';
import { BrBusinessEventsType } from 'types/BrTypes';
import { usePostMessageToIFrame } from 'hooks/usePostMessageToIFrame';
import { ClmPortalOutgoingPostMessageTypes } from 'utils/postMessageUtil';
import { AxiosError } from 'axios';
import { JBErrorDto } from '@bjb-gcrm/gcrm-frontend-components';

export const useCallBrBusinessEvent = (brId: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { postMessageToIFrameByType } = usePostMessageToIFrame();

  return useMutation<any, AxiosError<JBErrorDto>, { brUid: string; businessEvent: BrBusinessEventsType }>({
    mutationFn: (props) => callBrBusinessEvent(props.brUid, props.businessEvent),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getBr', brId] });
      dispatch(setBrTab(BrTabItems.CORE_DATA));
      postMessageToIFrameByType(ClmPortalOutgoingPostMessageTypes.RE_FETCH_CORE_DATA);
      dispatch(closeLastModal());
    },
    onError: (error) => {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error when calling BR business event in pcm-br-mgmt',
              title: 'Error when calling BR business event',
              userErrorMessage: 'An error occurred while calling BR business event',
            },
            httpError: error,
          },
        }),
      );
    },
  });
};
